export default {
  title: {
    type: 'Label',
    name: '7',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px'
  },
  name: {
    type: 'Paragraph',
    name: '1',
    fontSize: 38,
    fontWeight: 400,
    lineHeight: '47.5px',
    md: {
      fontSize: 30,
      fontWeight: 400,
      lineHeight: '37.5px'
    }
  },
  bio: {
    type: 'Paragraph',
    name: '3',
    fontSize: 22,
    fontWeight: 400,
    lineHeight: '33px'
  },
  contact: {
    type: 'Paragraph',
    name: '4',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '25px'
  }
}
